import { useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button/CaptionButton';
import { EditModeSelectDialog } from '~/shared/components/ui/';

export const UISampleEditModeSelectDialogs = () => {
  const [result, setResult] = useState('');
  const [isShow, setIsShow] = useState(false);

  return (
    <div className="categories">
      <h3 id="dialog">編集モード選択ダイアログ</h3>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setResult('');
                setIsShow(true);
              }}
            />
            <EditModeSelectDialog
              isOpen={isShow}
              onAIEditDecision={() => {
                setResult('AIアシスト編集');
                setIsShow(false);
              }}
              onStandardEditDecision={() => {
                setResult('通常編集');
                setIsShow(false);
              }}
              onCancel={() => {
                setResult('キャンセルしました');
                setIsShow(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">{result}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
